var CSVOrderInputFields;
(function (CSVOrderInputFields) {
    CSVOrderInputFields["INITIATING_OFFICE_ID"] = "Initiating office ID";
    CSVOrderInputFields["MEDICAL_OFFICE_ID"] = "Medical office ID";
    CSVOrderInputFields["PRESCRIBER_ID"] = "Prescriber ID";
    CSVOrderInputFields["DRAFT_ORDER_ID"] = "Draft order ID (optional)";
    CSVOrderInputFields["PATIENT_FIRST_NAME"] = "Patient first name";
    CSVOrderInputFields["PATIENT_MIDDLE_INITIAL"] = "Middle Initial";
    CSVOrderInputFields["PATIENT_LAST_NAME"] = "Patient last name";
    CSVOrderInputFields["PATIENT_DOB"] = "Patient DoB";
    CSVOrderInputFields["PATIENT_SEX"] = "Patient sex";
    CSVOrderInputFields["PATIENT_PHONE"] = "Patient phone";
    CSVOrderInputFields["PATIENT_EMAIL"] = "Patient email";
    CSVOrderInputFields["ICD_10_CODES"] = "ICD-10 codes";
    CSVOrderInputFields["PLACE_ACCOUNT_ID"] = "Lab account ID";
    CSVOrderInputFields["PRODUCT_ID"] = "ProductIDs";
})(CSVOrderInputFields || (CSVOrderInputFields = {}));
const expectedFormat = {
    [CSVOrderInputFields.INITIATING_OFFICE_ID]: {
        type: 'string',
        field: CSVOrderInputFields.INITIATING_OFFICE_ID,
        example: '1234',
    },
    [CSVOrderInputFields.MEDICAL_OFFICE_ID]: {
        type: 'string',
        field: CSVOrderInputFields.MEDICAL_OFFICE_ID,
        example: '1234',
    },
    [CSVOrderInputFields.PRESCRIBER_ID]: {
        type: 'string',
        field: CSVOrderInputFields.PRESCRIBER_ID,
        example: '1234',
    },
    [CSVOrderInputFields.DRAFT_ORDER_ID]: {
        type: 'string (optional)',
        field: CSVOrderInputFields.DRAFT_ORDER_ID,
        example: '1234',
    },
    [CSVOrderInputFields.PATIENT_FIRST_NAME]: {
        type: 'string',
        field: CSVOrderInputFields.PATIENT_FIRST_NAME,
        example: 'John',
    },
    [CSVOrderInputFields.PATIENT_MIDDLE_INITIAL]: {
        type: 'string',
        field: CSVOrderInputFields.PATIENT_MIDDLE_INITIAL,
        example: 'D',
    },
    [CSVOrderInputFields.PATIENT_LAST_NAME]: {
        type: 'string',
        field: CSVOrderInputFields.PATIENT_LAST_NAME,
        example: 'Doe',
    },
    [CSVOrderInputFields.PATIENT_DOB]: {
        type: 'timestamp',
        field: CSVOrderInputFields.PATIENT_DOB,
        example: '01-24-1997',
    },
    [CSVOrderInputFields.PATIENT_SEX]: {
        type: 'string (M/F)',
        field: CSVOrderInputFields.PATIENT_SEX,
        example: 'M',
    },
    [CSVOrderInputFields.PATIENT_PHONE]: {
        type: 'string (assume US)',
        field: CSVOrderInputFields.PATIENT_PHONE,
        example: '8005551234',
    },
    [CSVOrderInputFields.PATIENT_EMAIL]: {
        type: 'string',
        field: CSVOrderInputFields.PATIENT_EMAIL,
        example: 'john@doe.com',
    },
    [CSVOrderInputFields.ICD_10_CODES]: {
        type: 'string values separarated by spaces',
        field: CSVOrderInputFields.ICD_10_CODES,
        example: 'A00.0 A00.1',
    },
    [CSVOrderInputFields.PLACE_ACCOUNT_ID]: {
        type: 'string',
        field: CSVOrderInputFields.PLACE_ACCOUNT_ID,
        example: '1234',
    },
    [CSVOrderInputFields.PRODUCT_ID]: {
        type: 'string values separated by spaces',
        field: CSVOrderInputFields.PRODUCT_ID,
        example: '1234 5678',
    },
};

export { CSVOrderInputFields, expectedFormat };
